import React, {Fragment} from 'react';
import ReactModal from 'react-modal';

import ButtonRow from '../common/ButtonRow';
import FlatButton from '../common/FlatButton';
import PrimaryFlatButton from '../common/PrimaryFlatButton';
import theme from '../../constants/theme';
import styled from 'styled-components';

ReactModal.setAppElement('#root');

const ModalContent = styled.div`
  margin: 20px;
`;
const ConfirmModal = ({title, question, isVisible, confirm, cancel}) => {
  return (
    <Fragment>
      <ReactModal
        isOpen={isVisible}
        contentLabel={title}
        onRequestClose={cancel}
        style={{
          overlay: {
            backgroundColor: theme.primaryColorOverlay,
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            color: 'black',
            height: 180,
            width: 600,
          },
        }}>
        <ModalContent>{question}</ModalContent>
        <ButtonRow>
          <FlatButton onClick={cancel}>Abbrechen</FlatButton>
          <PrimaryFlatButton dark onClick={confirm}>
            Ja
          </PrimaryFlatButton>
        </ButtonRow>
      </ReactModal>
    </Fragment>
  );
};

export default ConfirmModal;
